import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { Component } from '@angular/core';

@Component({
  selector: 'cng-agent-booking-chat-inprocess-forward',
  templateUrl: './agent-booking-chat-inprocess-forward.component.html',
})
export class AgentBookingChatInprocessForwardComponent {
  readonly responseId$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.ResponseId.select);
  readonly isConf$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.IsConf.select);

  constructor(private readonly router: AgentDesktopRouter) {}
}
